module.exports = __webpack_public_path__ + "img/img16.31d8a1d7.svg";